<template>
  <div>
    <b>Status: {{ statuses }}</b>
    <p v-if="statuses == 'rejected'" style="color:red">
      {{ rejectionMessage }}
    </p>
    <button v-if="statuses != 'approved' && status != 'paid'" type="button" id="approveBtn"
      v-on:click="callParentFunction('approved', flag)" class="btn btn-primary">
      Approve
    </button>
    <button v-if="statuses != 'rejected' && status != 'paid'" type="button" id="rejectBtn"
      v-on:click="callParentFunction('rejected', flag)" class="btn btn-danger">
      Reject
    </button>
    <button v-if="status != 'paid' && showEditButton" type="button"
      v-on:click="callEditSectionOnParent(flag)" class="btn btn-primary">
      <i class="fp-edit"></i> Edit
    </button>
  </div>
</template>
<script>
export default {
  name: "EvWarrantyClaimStatusButtons",
  props: ['statuses','status','rejectionMessage','flag','updateTabularStatus','editSection','showEditButton'],
  methods: {
    callParentFunction(status,flag){
      this.updateTabularStatus(status,flag)
    },
    callEditSectionOnParent(sectionName){
      this.editSection(sectionName);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/EvWarrantyClaimStatusButtons.vue